import styles from "../../../../css/privateKey.module.css";
import Button from "../../../../components/shared/Button";
import Modal from "react-modal";
import useTheme from "../../../../config/useTheme";
import useCustomStyles from "../../../../config/useCustomStyles";
import PrivateKeyField from "components/shared/private-key-field/PrivateKeyField";
export default function AccountExists({
  accountExistModal,
  setAccountExistModal,
  handlePrivateKey,
  privateKey,
  account,
  setAccount,
}) {
  const { dark } = useTheme();

  const customStyles = useCustomStyles()

  const handleConfirm = () => {
    setAccountExistModal(false);
  };
  const handleCancel = () => {
    setAccount("");
  };
  return (
    <Modal
      isOpen={accountExistModal}
      ariaHideApp={false}
      // onAfterOpen={afterOpenModal}
      // onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Modal"
    >
      <div className={`${styles.privateKey} ${dark? styles.dark : ''}`}>
        <div className={styles.text}>
          <p className={styles.mainMessage}>
            It looks like that <span className={styles.noted}>{account}</span>{" "}
            already exists...
          </p>
          <p>
            To verify that your data is not compromised, please fill in the
            field bellow with your private key
          </p>
        </div>
        <PrivateKeyField
          value={privateKey}
          onChange={(e) => handlePrivateKey(e.target.value)}
          placeholder="Enter your private key"
        />
        <div className={styles.btnGroup}>
          <Button onClick={handleConfirm} text="Confirm" />
          <Button onClick={handleCancel} text="Create new account instead" />
        </div>
      </div>
    </Modal>
  );
}
